import React from 'react'

import LoadingOverlay from '@/components/widgets/LoadingOverlay'
import { cn } from '@/lib/utils'

type Props = React.HTMLAttributes<HTMLDivElement> & {
  isLoading: boolean
}

const DataTableContainer: React.FC<Props> = ({
  isLoading,
  className,
  children,
  ...props
}) => (
  <div className={cn('relative overflow-auto', className)} {...props}>
    <LoadingOverlay isActive={isLoading} showSpinner={false}>
      {children}
    </LoadingOverlay>
  </div>
)

export default DataTableContainer
